<template>
    <a href="javascript:;"
        class="img-pdetail-list"
        @click="handleChange(src)">
        <img v-lazy="src" alt="">
    </a>
</template>

<script>
export default {
    props: [ "src", "handleChange" ],
}
</script>

<style scoped>
.img-pdetail-list{
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
}
.img-pdetail-list>img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
}
</style>
